"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAimsAccountJobs = exports.getAimsAccount = exports.getAimsAccountHistory = void 0;
const axios_1 = __importDefault(require("axios"));
async function getAimsAccountHistory(accountCode, params = {}) {
    console.log('getAccountHistory:accountCode, params', accountCode, params);
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `/https-aims/api/aims/accounts/${accountCode}/history`,
        params
    });
    return resp.data;
}
exports.getAimsAccountHistory = getAimsAccountHistory;
async function getAimsAccount(accountCode, params = {}) {
    console.log('getAccount:accountCode, params', accountCode, params);
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `/https-aims/api/aims/accounts/${accountCode}`,
        params
    });
    return resp.data;
}
exports.getAimsAccount = getAimsAccount;
async function getAimsAccountJobs(accountCode, params = {}) {
    console.log('getAccountJobs:accountCode, params', accountCode, params);
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `/https-aims/api/aims/accounts/${accountCode}/jobs`,
        params
    });
    return resp.data;
}
exports.getAimsAccountJobs = getAimsAccountJobs;
